module.exports = __webpack_public_path__ + "media/src/assets/Images/MapPin-072875c31e44cbc49dc59b8174d6e311.svg";